import {
    PHONE_NUM_MAX,
    PHONE_NUM_MIN
} from 'app/constants';

export const ValidatePhoneDirectiveModule = angular
    .module('app.directives.validatePhone', [])
    .directive('vlnValidatePhone', () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, element, attrs, ngModelCtrl) => {
                ngModelCtrl.$validators.validPhone = (modelValue, viewValue) => {
                    const value = modelValue || viewValue;
                    if (value == null || value === '' || value === '(') return true;
                    const regExp = new RegExp(`^\\s*(\\d{${PHONE_NUM_MIN},${PHONE_NUM_MAX}})\\s*$`);
                    return regExp.test(value);
                };
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/validatePhone.directive.js